import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import WebsiteGif from '@/assets/Projects/WebsitePhotos/WebsiteGif.gif';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebsiteProjectSpec',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'clairgreen.com',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Solo Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "October 2024 - Present")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " When I think about why I chose Computer Science, my own website immediately comes to mind. It is my purest form of bringing my ideas to life through code, a phrase that I use very often to explain my experience with the subject. Out of pure passion, I have iterated through version after version of clairgreen.com, adding new pages, more features and animations, and in some cases, an entirely new style. this project embodies my love for creation, especially having the ability to pull ideas directly from my imagination and make them a reality. "),
          _createElementVNode("span", { class: "block" }, [
            _createTextVNode(" This website heavily builds on my experience at "),
            _createElementVNode("a", {
              class: "link-in-text",
              href: "/skills-experience"
            }, "BoxCast"),
            _createTextVNode(", primarily by building entirely from scratch in Vue.js, focusing on reactive and easy-to-use designs, and promoting clean code throughout the process. No one but me can see it, yet I'm truly proud of the structure bringing this passion project together. With 10 reactive pages, 5 animations designed by me from scratch, and a style system that reflects both my personality and willingness to step beyond norms, this website has become my favorite project yet. All without a single line of AI-generated code. ")
          ])
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[60%] h-auto rounded-lg cursor-pointer",
            src: _unref(WebsiteGif),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(WebsiteGif), 'clairgreen.com Demo', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})